<template>
  <v-row>
    <v-col cols="12" md="6" lg="6" sm="8">
      <b-field style="margin-bottom: -20px;" class="file">
        <b-upload v-model="file" @input="handleOnInput">
          <a class="button is-primary">
            <span v-text="text" />
            <b-icon icon="upload" v-if="!loading" />
            <Lynx-Spinner class="ml-2" color="neutral-100" size="4" v-else />
          </a>
        </b-upload>
      </b-field>
    </v-col>
    <v-col cols="12" md="7" lg="7" sm="7" v-if="file">
      <span class="file-name bg-white">
        {{ file.name }}
      </span>
    </v-col>
  </v-row>
</template>

<script>
import { arquivosCreateRequest } from "@/services/requests/arquivos";
import base64Files from "@/mixins/base64Files";

export default {
  name: "InputFile",
  mixins: [base64Files],
  props: {
    text: {
      default: "Upload",
      type: String,
    },
  },
  data() {
    return {
      file: null,
      loading: false,
    };
  },
  methods: {
    async submit() {
      return new Promise((resolve) => {
        if (!this.file) {
          resolve();
          return;
        }
        this.loading = true;
        const formData = new FormData();
        formData.append("arquivo", this.file);
        arquivosCreateRequest(formData)
          .then((res) => {
            resolve(res.data.id);
            this.file = null;
          })
          .finally(() => (this.loading = false));
      });
    },
    base64File() {
      return this.fileToBase64(this.file);
    },
    async handleOnInput() {
      this.loading = true;
      let file = await this.base64File();
      this.$emit("input", file);
      this.loading = false;
    },
  },
};
</script>
